Namespace 'Customer.Webchat'

class Customer.Webchat.WebchatHistoryMessage extends Backbone.Model
  defaults:
    text: undefined
    timestamp: undefined
    isOwn: undefined

  text: ->
    @get 'text'

  timestamp: ->
    new moment(@get('timestamp')).format 'HH:mm'

  source: ->
    if @get 'isOwn' then 'own' else 'foreign'
